import { render, staticRenderFns } from "./PersonalInjury.vue?vue&type=template&id=20fdd2b4&scoped=true&"
import script from "./PersonalInjury.vue?vue&type=script&lang=tsx&"
export * from "./PersonalInjury.vue?vue&type=script&lang=tsx&"
import style0 from "./PersonalInjury.vue?vue&type=style&index=0&id=20fdd2b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fdd2b4",
  null
  
)

export default component.exports